"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatBytes = exports.BYTE_TABLE = exports.UNIT_SUFFIXES = exports.UNITS = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
exports.UNITS = {
    AUTO: 'AUTO',
    BYTES: 'BYTES',
    KILOBYTE: 'KILOBYTE',
    MEGABYTE: 'MEGABYTE',
    GIGABYTE: 'GIGABYTE',
    TERABYTE: 'TERABYTE',
    PETABYTE: 'PETABYTE',
    EXABYTE: 'EXABYTE',
    ZETTABYTE: 'ZETTABYTE',
    YOTTABYTE: 'YOTTABYTE',
};
exports.UNIT_SUFFIXES = (_a = {},
    _a[exports.UNITS.BYTES] = 'Bytes',
    _a[exports.UNITS.KILOBYTE] = 'KB',
    _a[exports.UNITS.MEGABYTE] = 'MB',
    _a[exports.UNITS.GIGABYTE] = 'GB',
    _a[exports.UNITS.TERABYTE] = 'TB',
    _a[exports.UNITS.PETABYTE] = 'PB',
    _a[exports.UNITS.EXABYTE] = 'EB',
    _a[exports.UNITS.ZETTABYTE] = 'ZB',
    _a[exports.UNITS.YOTTABYTE] = 'YB',
    _a);
exports.BYTE_TABLE = (_b = {},
    _b[exports.UNITS.BYTES] = 1,
    _b[exports.UNITS.KILOBYTE] = 1024,
    _b[exports.UNITS.MEGABYTE] = Math.pow(1024, 2),
    _b[exports.UNITS.GIGABYTE] = Math.pow(1024, 3),
    _b[exports.UNITS.TERABYTE] = Math.pow(1024, 4),
    _b[exports.UNITS.PETABYTE] = Math.pow(1024, 5),
    _b[exports.UNITS.EXABYTE] = Math.pow(1024, 6),
    _b[exports.UNITS.ZETTABYTE] = Math.pow(1024, 7),
    _b[exports.UNITS.YOTTABYTE] = Math.pow(1024, 8),
    _b);
var formatBytes = function (bytes, decimals) {
    if (bytes === 0)
        return "0 " + exports.UNIT_SUFFIXES.BYTES;
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    var size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    var unit = Object.values(exports.UNIT_SUFFIXES)[i];
    return size + " " + unit;
};
exports.formatBytes = formatBytes;
function FileSize(_a) {
    var bytes = _a.bytes, _b = _a.decimals, decimals = _b === void 0 ? 0 : _b, _c = _a.as, as = _c === void 0 ? exports.UNITS.AUTO : _c;
    if (!as || !Object.values(exports.UNITS).includes(as)) {
        throw new Error("FileSize error: Unknown unit '" + as + "'");
    }
    if (as === exports.UNITS.AUTO)
        return jsx_runtime_1.jsx("span", { children: exports.formatBytes(bytes, decimals) }, void 0);
    var size = (bytes / exports.BYTE_TABLE[as]).toFixed(decimals);
    return jsx_runtime_1.jsx("span", { children: size + " " + exports.UNIT_SUFFIXES[as] }, void 0);
}
exports.default = FileSize;
//# sourceMappingURL=FileSize.js.map